<template>
  <div v-if="productsLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
  <error-page :error="productsError"></error-page>
  <div v-if="productsLoaded" class="cr-catalog">
    <div class="cr-container">
      <div class="cr-catalog__number">
        {{ product_total }} {{num_word(product_total, ['товар','товара','товаров'])}}
      </div>
      <div v-if="countFilter > 0 || product_total > 0" class="cr-filter">
        <form class="cr-filter__form cr-form" action="https://httpbin.org/anything" method="get" autocomplete="off">
          <div class="cr-filter__top">
            <div class="cr-filter__sorting">
              <button @click="sortShow=true" class="cr-filter__button-sorting simulated-hover" type="button">
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <use xlink:href="/assets/img/svg/sprite.svg#icon-sorting"></use>
                </svg>
              </button>
            </div>
            <div class="cr-filter__filters">
              <button @click="filterShow=true" class="cr-filter__button-filters simulated-hover" type="button">
                Фильтры
                <span v-if="countFilter > 0" class="cr-filter__button-label">
                                        {{ countFilter }}
                                    </span>
              </button>
            </div>
            <button v-if="countFilter > 0" @click="dataFilter = {}; setFilter();" class="cr-filter__button-reset" type="reset">
              Сбросить фильтры
              <svg width="14" height="14" viewBox="0 0 14 14">
                <use xlink:href="/assets/img/svg/sprite.svg#icon-cross"></use>
              </svg>
            </button>
          </div>
        </form>
      </div>
      <ul v-if="product_total > 0" class="cr-catalog__list">
        <li class="cr-catalog__item" v-for="item in products">
          <product-item :product="item" />
        </li>
      </ul>
      <div v-else>Ничего не найдено</div>
      <div v-if="loadingMore" class="mc-loader"><span class="mc-loader__circle"></span></div>
    </div>
  </div>

  <div class="cr-modal" :class="{isOpen: sortShow}" id="sortingModal">
    <div class="cr-modal__outer">
      <div class="cr-modal__inner">
        <div class="cr-modal__heading">
          <button @click="sortShow=false" class="cr-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="cr-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-1"></use>
            </svg>
          </button>
          <div class="cr-modal__title">
            Сортировка
          </div>
        </div>
        <div class="cr-modal__body">
          <ul class="cr-form__options-list">
            <li v-for="item in sort" class="cr-form__options-item">
              <div class="cr-form__field">
                <input class="cr-form__radio" type="radio" v-model="sortCurrent" :id="'sorting'+item.id" :value="item.id" :checked="sortCurrent==item.id">
                <label @click="sortProduct(item.id)" class="cr-form__label simulated-hover" :for="'sorting'+item.id">
                  {{ item.name }}
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="cr-modal__bottom">
          <button @click="sortShow=false" class="cr-button js-button-close" type="button">
                                                    <span class="cr-button__text">
                                                        Закрыть
                                                    </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="cr-modal" :class="{isOpen: filterShow}" id="filtersModal">
    <div class="cr-modal__outer">
      <div class="cr-modal__inner">
        <div class="cr-modal__heading">
          <span class="cr-modal__line"></span>
          <button @click="filterShow=false" class="cr-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="cr-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-1"></use>
            </svg>
          </button>
          <div class="cr-modal__title">
            Фильтры
          </div>
        </div>
        <div class="cr-modal__body">
          <div v-if="filterLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
          <div v-if="filterError" class="mc-error">{{ productsError }}</div>
          <div v-if="filterLoaded" class="cr-filter__body">
            <div class="cr-filter__output cr-output">
              <ul class="cr-output__list">
                <template v-for="item in filter.ITEMS">
                  <template v-if="item.PRICE">
                    <li v-if="item.VALUES.MIN.HTML_VALUE" class="cr-output__item">
                      <button @click="uncheckFilter(item.VALUES.MIN.CONTROL_NAME, 'unset')" class="cr-output__button js-button-delete" type="button">
                        от {{item.VALUES.MIN.HTML_VALUE}}
                        <svg class="cr-output__cross" width="18" height="18" viewBox="0 0 18 18">
                          <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-2"></use>
                        </svg>
                      </button>
                    </li>
                    <li v-if="item.VALUES.MAX.HTML_VALUE" class="cr-output__item">
                      <button @click="uncheckFilter(item.VALUES.MAX.CONTROL_NAME, 'unset')" class="cr-output__button js-button-delete" type="button">
                        до {{item.VALUES.MAX.HTML_VALUE}}
                        <svg class="cr-output__cross" width="18" height="18" viewBox="0 0 18 18">
                          <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-2"></use>
                        </svg>
                      </button>
                    </li>
                  </template>
                </template>
                <template v-for="item in filter.ITEMS">
                  <template v-for="value in item.VALUES">
                    <li v-if="value.CHECKED" class="cr-output__item">
                  <button @click="uncheckFilter(value.CONTROL_NAME)" class="cr-output__button js-button-delete" type="button">
                    {{value.VALUE}}
                    <svg class="cr-output__cross" width="18" height="18" viewBox="0 0 18 18">
                      <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-2"></use>
                    </svg>
                  </button>
                </li>
                  </template>
                </template>
              </ul>
              <button v-if="countFilter > 0" @click="dataFilter = {}; setFilter();" class="cr-output__button-reset" type="reset">
                Сбросить фильтры
                <svg width="14" height="14" viewBox="0 0 14 14">
                  <use xlink:href="/assets/img/svg/sprite.svg#icon-cross"></use>
                </svg>
              </button>
            </div>
            <template v-for="item in filter.ITEMS">
            <div v-if="item.PRICE == true" class="cr-filter__section cr-filter-section">
              <div class="cr-filter-section__name">
                {{ item.NAME }}
              </div>
              <div class="cr-filter-section__body">
                <div class="cr-form__fieldset cr-form__fieldset--col2">
                  <div class="cr-form__field">
                    <input class="cr-form__input cr-form__input--sm" type="text" v-model="dataFilter[item.VALUES.MIN.CONTROL_NAME]" :placeholder="item.VALUES.MIN.VALUE">
                  </div>
                  <div class="cr-form__field">
                    <input class="cr-form__input cr-form__input--sm" type="text" v-model="dataFilter[item.VALUES.MAX.CONTROL_NAME]" :placeholder="item.VALUES.MAX.VALUE">
                  </div>
                </div>
              </div>
            </div>
            </template>
            <template v-for="item in filter.ITEMS">
            <div v-if="item.PRICE !== true && Object.values(item.VALUES).length > 0" class="cr-filter__section cr-filter-section">
              <div class="cr-filter-section__name">
                {{ item.NAME }}
              </div>
              <div class="cr-filter-section__body">
                <ul class="cr-filter-section__list">
                  <template v-for="(value, key, index) in item.VALUES">
                  <li v-if="index < 6" class="cr-filter-section__item">
                    <div class="cr-form__field" :class="{'cr-form__field-disabled':value.DISABLED}">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" v-model="dataFilter[value.CONTROL_NAME]" :value="value.HTML_VALUE"
                             true-value="Y"
                             false-value="N"
                             :id="value.CONTROL_ID"
                             :checked="value.CHECKED"
                             :disabled="value.DISABLED"
                      >
                      <label class="cr-form__label simulated-hover" :for="value.CONTROL_ID">
                        {{ value.VALUE }}
                      </label>
                    </div>
                  </li>
                  </template>
                  <li v-if="Object.values(item.VALUES).length > 6" @click="filterPropertyAll = item; propertyQuery=''" class="cr-filter-section__item">
                    <button class="cr-filter-section__button-all" type="button">
                      Все
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            </template>
            <div v-if="false" class="cr-filter__section cr-filter-section">
              <div class="cr-filter-section__name">
                Тара
              </div>
              <div class="cr-filter-section__body">
                <ul class="cr-filter-section__list">
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="container1" id="container1">
                      <label class="cr-form__label simulated-hover" for="container1">
                        Бутылка
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="container2" id="container2">
                      <label class="cr-form__label simulated-hover" for="container2">
                        Ж/Б
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="container3" id="container3">
                      <label class="cr-form__label simulated-hover" for="container3">
                        ПЭТ
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="container4" id="container4">
                      <label class="cr-form__label simulated-hover" for="container4">
                        Саше
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="false" class="cr-filter__section cr-filter-section">
              <div class="cr-filter-section__name">
                Стиль
              </div>
              <div class="cr-filter-section__body">
                <ul class="cr-filter-section__list">
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style1" id="style1">
                      <label class="cr-form__label simulated-hover" for="style1">
                        American IPA
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style2" id="style2">
                      <label class="cr-form__label simulated-hover" for="style2">
                        APA
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style3" id="style3">
                      <label class="cr-form__label simulated-hover" for="style3">
                        DIPA
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style4" id="style4">
                      <label class="cr-form__label simulated-hover" for="style4">
                        Fruit Beer
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style5" id="style5">
                      <label class="cr-form__label simulated-hover" for="style5">
                        Helles
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style6" id="style6">
                      <label class="cr-form__label simulated-hover" for="style6">
                        IPA
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style7" id="style7">
                      <label class="cr-form__label simulated-hover" for="style7">
                        Mead
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style8" id="style8">
                      <label class="cr-form__label simulated-hover" for="style8">
                        Milk Stout
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style9" id="style9">
                      <label class="cr-form__label simulated-hover" for="style9">
                        New England IPA
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style10" id="style10">
                      <label class="cr-form__label simulated-hover" for="style10">
                        Pilsner
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style11" id="style11">
                      <label class="cr-form__label simulated-hover" for="style11">
                        Smoothie Sour Ale
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style12" id="style12">
                      <label class="cr-form__label simulated-hover" for="style12">
                        Sour Fruited
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="style13" id="style13">
                      <label class="cr-form__label simulated-hover" for="style13">
                        Tomato Gose
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <button class="cr-filter-section__button-all" type="button">
                      Все стили
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="false" class="cr-filter__section cr-filter-section">
              <div class="cr-filter-section__name">
                ABV
              </div>
              <div class="cr-filter-section__body">
                <ul class="cr-filter-section__list">
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="ABV1" id="ABV1">
                      <label class="cr-form__label simulated-hover" for="ABV1">
                        4,5
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="ABV2" id="ABV2">
                      <label class="cr-form__label simulated-hover" for="ABV2">
                        4,7
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="ABV3" id="ABV3">
                      <label class="cr-form__label simulated-hover" for="ABV3">
                        4,8
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="ABV4" id="ABV4">
                      <label class="cr-form__label simulated-hover" for="ABV4">
                        5
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="ABV5" id="ABV5">
                      <label class="cr-form__label simulated-hover" for="ABV5">
                        5,5
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="ABV6" id="ABV6">
                      <label class="cr-form__label simulated-hover" for="ABV6">
                        6
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <button class="cr-filter-section__button-all" type="button">
                      Все
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="false" class="cr-filter__section cr-filter-section">
              <div class="cr-filter-section__name">
                Объем
              </div>
              <div class="cr-filter-section__body">
                <ul class="cr-filter-section__list">
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume1" id="volume1">
                      <label class="cr-form__label simulated-hover" for="volume1">
                        0,2
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume2" id="volume2">
                      <label class="cr-form__label simulated-hover" for="volume2">
                        0,25
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume3" id="volume3">
                      <label class="cr-form__label simulated-hover" for="volume3">
                        0,33
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume4" id="volume4">
                      <label class="cr-form__label simulated-hover" for="volume4">
                        0,375
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume5" id="volume5">
                      <label class="cr-form__label simulated-hover" for="volume5">
                        0,45
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume6" id="volume6">
                      <label class="cr-form__label simulated-hover" for="volume6">
                        0,5
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume7" id="volume7">
                      <label class="cr-form__label simulated-hover" for="volume7">
                        0,75
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume8" id="volume8">
                      <label class="cr-form__label simulated-hover" for="volume8">
                        1,5
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume9" id="volume9">
                      <label class="cr-form__label simulated-hover" for="volume9">
                        10
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume10" id="volume10">
                      <label class="cr-form__label simulated-hover" for="volume10">
                        20
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="volume11" id="volume11">
                      <label class="cr-form__label simulated-hover" for="volume11">
                        30
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="false" class="cr-filter__section cr-filter-section">
              <div class="cr-filter-section__name">
                Фитинг
              </div>
              <div class="cr-filter-section__body">
                <ul class="cr-filter-section__list">
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="fitting1" id="fitting1">
                      <label class="cr-form__label simulated-hover" for="fitting1">
                        A
                      </label>
                    </div>
                  </li>
                  <li class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" name="fitting2" id="fitting2">
                      <label class="cr-form__label simulated-hover" for="fitting2">
                        S
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="cr-modal__bottom cr-modal__bottom--col2">
          <button @click="setFilter" class="cr-button js-button-close" type="button">
                                <span class="cr-button__text">
                                    Применить
                                </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="cr-modal" :class="{isOpen: filterPropertyAll}" id="categoryFiltersModal">
    <div class="cr-modal__outer">
      <div class="cr-modal__inner">
        <div class="cr-modal__body">
          <div class="cr-submenu">
            <div class="cr-submenu__top">
              <button @click="filterPropertyAll=false" class="cr-submenu__button-back cr-icon-link simulated-hover" type="button" aria-label="Назад">
                <svg class="cr-icon-link__image" width="30" height="30" viewBox="0 0 30 30">
                  <use xlink:href="/assets/img/svg/sprite.svg#arrow-line-left"></use>
                </svg>
              </button>
              <button @click="clearFilter(filterPropertyAll.ID)" class="cr-submenu__button-reset" type="button">
                Сбросить фильтры
                <svg width="14" height="14" viewBox="0 0 14 14">
                  <use xlink:href="/assets/img/svg/sprite.svg#icon-cross"></use>
                </svg>
              </button>
            </div>
            <div class="cr-submenu__body">
              <div class="cr-submenu__title">
                {{ filterPropertyAll.NAME }}
              </div>
              <div class="cr-search-field">
                <button class="cr-search-field__button" type="submit" aria-label="Найти">
                  <svg class="cr-search-field__button-icon" width="20" height="20" viewBox="0 0 20 20">
                    <use xlink:href="/assets/img/svg/sprite.svg#icon-search"></use>
                  </svg>
                </button>
                <input @input="doSearch" :value="propertyQuery" class="cr-search-field__input js-input-search" type="search" name="search" placeholder="Поиск">
                <button class="cr-search-field__button-delete js-button-delete" type="button">
                  <svg class="cr-search-field__icon-delete" width="20" height="20" viewBox="0 0 25 25">
                    <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-3"></use>
                  </svg>
                </button>
              </div>
              <ul class="cr-form__options-list">
                <li v-for="item in filteredProperty.VALUES" class="cr-form__options-item">
                  <div class="cr-form__field" :class="{'cr-form__field-disabled':item.DISABLED}">
                    <input class="cr-form__checkbox cr-form__checkbox--big-button" type="checkbox" v-model="dataFilter[item.CONTROL_NAME]" :id="'filter_'+item.CONTROL_NAME" true-value="Y"
                           false-value="N"
                           :disabled="item.DISABLED"
                    >
                    <label class="cr-form__label simulated-hover" :for="'filter_'+item.CONTROL_NAME">
                      {{ item.VALUE }}
                      <span class="cr-form__label-number">
                                                        ({{ item.ELEMENT_COUNT }})
                                                    </span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="cr-modal__bottom cr-modal__bottom--col2">
          <button @click="filterPropertyAll=false" class="cr-button js-button-close" type="button">
                                <span class="cr-button__text">
                                    Показать
                                </span>
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductItem from './components/ProductItem.vue'
import num from '../mixin/num';
import httpBuildQuery  from "http-build-query";
import queryString from 'query-string';
import products from "@/store/products";
import ErrorPage from "@/views/components/ErrorPage.vue";

export default {
  data() {
    return {
      dataFilter: {},
      filterPropertyAll: false,
      sortShow: false,
      filterShow: false,
      loadingMore: false,
      currentPage: parseInt(this.$route.query.page) || 1,
      filterValues: [],
      sortCurrent: 'new',
      sort: [
        {
          id: 'new',
          name: 'Сначала новые'
        },
        {
          id: 'popular',
          name: 'Сначала популярные'
        },
        {
          id: 'price_asc',
          name: 'Сначала дешевле'
        },
        {
          id: 'price_desc',
          name: 'Сначала дороже'
        }
      ],
      propertyQuery: ''
    }
  },
  mixins: [num],
  beforeRouteLeave(to, from) {
    window.removeEventListener('scroll', this.handleScroll);
    //if (to.name != 'login')
    //  this.$store.dispatch('unLoader');
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  async created() {
    // Initialize data
    let search = this.$route.query.q ? this.$route.query.q : '';
    let filter = queryString.parse(window.location.search, {arrayFormat: 'index'});
    delete filter.q;

    // Reset page if no products are loaded
    if (this.products.length === 0) {
      this.currentPage = 1;
    }

    // Fetch initial data
    this.fetchProducts({
      id: this.$route.params.id, 
      page: this.currentPage, 
      sort: this.sortCurrent, 
      search: search, 
      filter: filter, 
      first: true
    });

    await this.fetchFilters({
      id: this.$route.params.id, 
      search: search, 
      filter: filter, 
      first: true
    });

    this.updateFilterValues();

    // Add scroll event listener when component is created
    window.addEventListener('scroll', this.handleScroll);

  },
  destroyed() {
    // Remove scroll event listener when component is destroyed
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    '$route.path'() {
      // Get search query and filter parameters
      let search = this.$route.query.q ? this.$route.query.q : '';
      let filter = queryString.parse(window.location.search, {arrayFormat: 'index'});
      delete filter.q;

      // Reset page when category changes
      if (this.section_id != this.$route.params.id) {
        this.currentPage = 1;
      }

      // Fetch new data for the changed route
      this.fetchProducts({
        id: this.$route.params.id, 
        page: this.currentPage, 
        sort: this.sortCurrent, 
        search: search, 
        first: true
      });

      this.fetchFilters({
        id: this.$route.params.id, 
        search: search, 
        first: true
      });
    },
    '$route.query.q'() {
      if (!this.$route.query.q)
        return;
      // Get search query and filter parameters
      let search = this.$route.query.q ? this.$route.query.q : '';
      let filter = queryString.parse(window.location.search, {arrayFormat: 'index'});
      delete filter.q;

      // Reset page when category changes
      if (this.section_id != this.$route.params.id) {
        this.currentPage = 1;
      }

      // Fetch new data for the changed route
      this.fetchProducts({
        id: this.$route.params.id,
        page: this.currentPage,
        sort: this.sortCurrent,
        search: search,
        first: false
      });

      this.fetchFilters({
        id: this.$route.params.id,
        search: search,
        first: true
      });
    },
    currentPage(newPage) {
      this.$router.replace({
        query: { ...this.$route.query, page: newPage }
      }, {
        force: true,
        shallow: true
      });
    },
    filterShow(newValue, oldValue) {
      if (newValue)
        document.querySelector("body").classList.add("isMainSearchOpen");
      else
        document.querySelector("body").classList.remove("isMainSearchOpen");
    }
  },
  computed: {
    ...mapGetters('products', [
      'products',
      'productsLoading',
      'productsError',
      'productsLoaded',
      'product_total',
        'noMoreProducts',
        'section',
        'section_id'
    ]),
    ...mapGetters('filter', [
      'filter',
      'filterLoading',
      'filterError',
      'filterLoaded'
    ]),
    countFilter() {
      if (!this.filter)
        return 0;
      let countFilter = 0;
      for (let i in this.filter.ITEMS) {
        if (this.filter.ITEMS[i].PRICE) {
          if (this.filter.ITEMS[i].VALUES.MIN.HTML_VALUE)
            countFilter++;
          if (this.filter.ITEMS[i].VALUES.MAX.HTML_VALUE)
            countFilter++;
        }
        else
        for (let j in this.filter.ITEMS[i].VALUES) {
          if (this.filter.ITEMS[i].VALUES[j].CHECKED) {
            countFilter++;
          }
        }
      }
      return countFilter;
    },
    filteredProperty() {
      return this.filterProperty();
    }
  },
  components: {
    ErrorPage,
    ProductItem
  },
  methods: {
    ...mapActions('products', [
      'fetchProducts'
    ]),
    ...mapActions('filter', [
      'fetchFilters'
    ]),
    handleScroll() {
      if (this.$route.name != 'category') {
        window.removeEventListener('scroll', this.handleScroll);
        return;
      }
      // Calculate if we've reached the bottom of the page
      const bottomOfWindow = Math.max(
          window.scrollY,
          document.documentElement.scrollTop,
          document.body.scrollTop
      ) + window.innerHeight >= document.documentElement.scrollHeight - 200;

      // If we are at the bottom of the page and not currently loading more products
      if (bottomOfWindow && !this.loadingMore && this.productsLoaded && !this.noMoreProducts) {
        this.loadMoreProducts();
      }
    },

    /**
     * Loads more products when the user scrolls to the bottom of the page
     */
    async loadMoreProducts() {
      // Prevent multiple simultaneous loading requests
      if (this.loadingMore) {
        return;
      }

      try {
        this.loadingMore = true;

        // Calculate next page and prepare parameters
        const nextPage = this.currentPage + 1;
        let filter = queryString.parse(window.location.search, {arrayFormat: 'index'});
        delete filter.q;
        let search = this.$route.query.q ? this.$route.query.q : '';

        // Fetch next page of products
        await this.fetchProducts({
          id: this.$route.params.id, 
          page: nextPage, 
          sort: this.sortCurrent, 
          filter: filter, 
          search: search
        });

        // Update current page only if fetch was successful
        this.currentPage++;
      } catch (error) {
        // Error is already handled in the store action
        console.error('Error loading more products:', error);
      } finally {
        // Always reset loading state
        this.loadingMore = false;
      }
    },
    /**
     * Changes the sort order of products
     * @param {string} sort - Sort parameter
     */
    sortProduct(sort) {
      // Update current sort
      this.sortCurrent = sort;

      // Get current filter and search parameters
      let filter = queryString.parse(window.location.search, {arrayFormat: 'index'});
      delete filter.q;
      let search = this.$route.query.q ? this.$route.query.q : '';

      // Reset to page 1 and fetch products with new sort
      this.currentPage = 1;
      this.fetchProducts({
        id: this.$route.params.id, 
        page: 1, 
        sort: sort, 
        filter: filter, 
        search: search
      });

      // Close sort modal after selection
      this.sortShow = false;
    },
    /**
     * Builds filter object from selected filter values
     * @returns {Object} Filter parameters object
     */
    getFilter() {
      const filter = {};

      // Return empty object if filters aren't available
      if (!this.filters || !Array.isArray(this.filters)) {
        return filter;
      }

      // Process each filter group
      this.filters.forEach(filterGroup => {
        if (!filterGroup.values || !filterGroup.code) {
          return; // Skip invalid filter groups
        }

        // Process each value in the filter group
        Object.values(filterGroup.values).forEach(value => {
          if (value.checked) {
            // Initialize array for this filter code if it doesn't exist
            if (!filter[filterGroup.code]) {
              filter[filterGroup.code] = [];
            }

            // Add the selected value ID to the filter
            if (value.id) {
              filter[filterGroup.code].push(value.id);
            }
          }
        });
      });

      return filter;
    },
    /**
     * Applies selected filters and fetches filtered products
     */
    async setFilter() {
      try {
        // Close filter modal
        this.filterShow = false;

        // Get current search query
        let search = this.$route.query.q ? this.$route.query.q : '';

        // Update URL with filter parameters
        this.$router.replace({
          query: { page: 1, q: search, ...this.dataFilter }
        }, {
          force: true,
          shallow: true
        });

        // Reset to page 1 when applying filters
        this.currentPage = 1;

        // Fetch filtered products
        this.fetchProducts({
          id: this.$route.params.id, 
          page: 1, 
          sort: this.sortCurrent, 
          filter: this.dataFilter, 
          search: search
        });

        // Update filter UI
        await this.fetchFilters({
          id: this.$route.params.id, 
          search: search, 
          filter: this.dataFilter
        });

        this.updateFilterValues();
      } catch (error) {
        console.error('Error applying filters:', error);
      }
    },
    /**
     * Clears all values for a specific filter
     * @param {string|number} id - Filter ID
     */
    clearFilter(id) {
      // Return early if filter data isn't available
      if (!this.filter || !this.filter.ITEMS || !this.filter.ITEMS[id] || !this.filter.ITEMS[id].VALUES) {
        return;
      }

      // Uncheck all values in the filter
      Object.values(this.filter.ITEMS[id].VALUES).forEach(value => {
        if (value.CONTROL_NAME) {
          // Update UI state
          value.CHECKED = false;
          // Update data model
          this.dataFilter[value.CONTROL_NAME] = 'N';
        }
      });
    },

    /**
     * Toggles a filter value
     * @param {string} id - Control name of the filter
     */
    checkFilter(id) {
      if (!id) {
        return;
      }

      // Toggle between Y and N
      this.dataFilter[id] = this.dataFilter[id] === 'Y' ? 'N' : 'Y';
    },

    /**
     * Unchecks a filter and applies the changes
     * @param {string} id - Control name of the filter
     * @param {string} value - Value to set ('N' by default, 'unset' to remove)
     */
    uncheckFilter(id, value = 'N') {
      if (!id) {
        return;
      }

      // Either remove the filter or set it to the specified value
      if (value === 'unset') {
        delete this.dataFilter[id];
      } else {
        this.dataFilter[id] = value;
      }

      // Apply the filter changes
      this.setFilter();
    },
    /**
     * Updates local filter values based on server response
     */
    updateFilterValues() {
      // Reset filter data
      this.dataFilter = {};

      // Return early if filter data isn't available
      if (!this.filter || !this.filter.ITEMS) {
        return;
      }

      // Process each filter item
      Object.entries(this.filter.ITEMS).forEach(([key, item]) => {
        // Handle price range filters
        if (item.PRICE) {
          // Set minimum price if available
          if (item.VALUES?.MIN?.HTML_VALUE && item.VALUES?.MIN?.CONTROL_NAME) {
            this.dataFilter[item.VALUES.MIN.CONTROL_NAME] = item.VALUES.MIN.HTML_VALUE;
          }

          // Set maximum price if available
          if (item.VALUES?.MAX?.HTML_VALUE && item.VALUES?.MAX?.CONTROL_NAME) {
            this.dataFilter[item.VALUES.MAX.CONTROL_NAME] = item.VALUES.MAX.HTML_VALUE;
          }
        } 
        // Handle other filter types
        else if (item.VALUES) {
          // Process each value in the filter
          Object.values(item.VALUES).forEach(value => {
            if (value.CHECKED && value.CONTROL_NAME) {
              this.dataFilter[value.CONTROL_NAME] = 'Y';
            }
          });
        }
      });
    },
    /**
     * Handles search input for filter properties
     * @param {Event} evt - Input event
     */
    doSearch(evt) {
      if (!evt || !evt.target) {
        return;
      }

      // Update search query with trimmed value
      this.propertyQuery = evt.target.value.trim();

      // Clear search field if button with class js-button-delete is clicked
      if (evt.target.nextElementSibling && evt.target.nextElementSibling.classList.contains('js-button-delete')) {
        evt.target.nextElementSibling.addEventListener('click', () => {
          this.propertyQuery = '';
          evt.target.value = '';
        });
      }
    },
    /**
     * Filters property values based on search query
     * @returns {Object} Filtered property object
     */
    filterProperty() {
      // If no search query, return all properties
      if (!this.propertyQuery || !this.filterPropertyAll) {
        return this.filterPropertyAll;
      }

      // Create a deep copy of the filter property object
      const result = JSON.parse(JSON.stringify(this.filterPropertyAll));

      // Convert search query to lowercase for case-insensitive comparison
      const searchQuery = this.propertyQuery.toLowerCase().trim();

      // Filter values that match the search query
      const filteredValues = Object.values(this.filterPropertyAll.VALUES || {}).filter(item => 
        item.VALUE && item.VALUE.toLowerCase().includes(searchQuery)
      );

      // Update the result with filtered values
      result.VALUES = filteredValues.length > 0 ? filteredValues : [];

      return result;
    },
  },
}
</script>
